import { lazy } from 'react';

export const PlayerSessionLimitsForm = lazy(
  () => import('./PlayerSessionLimitsForm'),
);
